// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Home Page - Rich Text Content Styles */

/* Hero Description */
.hero-description p {
  margin-bottom: 1em;
}

.hero-description strong {
  font-weight: bold !important;
}

.hero-description em {
  font-style: italic !important;
}

.hero-description u {
  text-decoration: underline !important;
}

.hero-description h1,
.hero-description h2,
.hero-description h3 {
  font-weight: bold !important;
  margin-bottom: 0.5em !important;
}

.hero-description ul,
.hero-description ol {
  padding-left: 2em !important;
  margin-bottom: 1em !important;
}

.hero-description ul {
  list-style-type: disc !important;
}

.hero-description ol {
  list-style-type: decimal !important;
}

.hero-description a {
  color: #fbbf24 !important;
  text-decoration: underline !important;
}

/* Featured Programs Description */
.program-description p {
  margin-bottom: 0.5em;
}

.program-description strong {
  font-weight: bold !important;
}

.program-description em {
  font-style: italic !important;
}

.program-description ul,
.program-description ol {
  padding-left: 1.5em !important;
  margin-bottom: 0.5em !important;
  font-size: 0.875rem !important;
}

.program-description ul {
  list-style-type: disc !important;
}

.program-description ol {
  list-style-type: decimal !important;
}

/* Why Choose Features Description */
.feature-description p {
  margin-bottom: 0.5em;
}

.feature-description strong {
  font-weight: bold !important;
}

.feature-description em {
  font-style: italic !important;
}

.feature-description ul,
.feature-description ol {
  padding-left: 1.5em !important;
  margin-bottom: 0.5em !important;
}

.feature-description ul {
  list-style-type: disc !important;
}

.feature-description ol {
  list-style-type: decimal !important;
}

/* Testimonials Text */
.testimonial-text p {
  margin-bottom: 0.5em;
}

.testimonial-text strong {
  font-weight: bold !important;
}

.testimonial-text em {
  font-style: italic !important;
}

/* CTA Description */
.cta-description p {
  margin-bottom: 0.5em;
}

.cta-description strong {
  font-weight: bold !important;
}

.cta-description em {
  font-style: italic !important;
}

.cta-description ul,
.cta-description ol {
  padding-left: 2em !important;
  margin-bottom: 1em !important;
}

.cta-description ul {
  list-style-type: disc !important;
}

.cta-description ol {
  list-style-type: decimal !important;
}

/* Quill alignment classes */
.ql-align-center {
  text-align: center !important;
}

.ql-align-right {
  text-align: right !important;
}

.ql-align-justify {
  text-align: justify !important;
}

/* Quill font sizes */
.ql-size-small {
  font-size: 0.75em !important;
}

.ql-size-large {
  font-size: 1.5em !important;
}

.ql-size-huge {
  font-size: 2.5em !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/StandardHomePage.css"],"names":[],"mappings":"AAAA,yCAAyC;;AAEzC,qBAAqB;AACrB;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;;EAGE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;;EAEE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA,kCAAkC;AAClC;EACE,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;EAC9B,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,oCAAoC;AACpC;EACE,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,sBAAsB;AACtB;EACE,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,4BAA4B;AAC5B;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,qBAAqB;AACrB;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":["/* Home Page - Rich Text Content Styles */\n\n/* Hero Description */\n.hero-description p {\n  margin-bottom: 1em;\n}\n\n.hero-description strong {\n  font-weight: bold !important;\n}\n\n.hero-description em {\n  font-style: italic !important;\n}\n\n.hero-description u {\n  text-decoration: underline !important;\n}\n\n.hero-description h1,\n.hero-description h2,\n.hero-description h3 {\n  font-weight: bold !important;\n  margin-bottom: 0.5em !important;\n}\n\n.hero-description ul,\n.hero-description ol {\n  padding-left: 2em !important;\n  margin-bottom: 1em !important;\n}\n\n.hero-description ul {\n  list-style-type: disc !important;\n}\n\n.hero-description ol {\n  list-style-type: decimal !important;\n}\n\n.hero-description a {\n  color: #fbbf24 !important;\n  text-decoration: underline !important;\n}\n\n/* Featured Programs Description */\n.program-description p {\n  margin-bottom: 0.5em;\n}\n\n.program-description strong {\n  font-weight: bold !important;\n}\n\n.program-description em {\n  font-style: italic !important;\n}\n\n.program-description ul,\n.program-description ol {\n  padding-left: 1.5em !important;\n  margin-bottom: 0.5em !important;\n  font-size: 0.875rem !important;\n}\n\n.program-description ul {\n  list-style-type: disc !important;\n}\n\n.program-description ol {\n  list-style-type: decimal !important;\n}\n\n/* Why Choose Features Description */\n.feature-description p {\n  margin-bottom: 0.5em;\n}\n\n.feature-description strong {\n  font-weight: bold !important;\n}\n\n.feature-description em {\n  font-style: italic !important;\n}\n\n.feature-description ul,\n.feature-description ol {\n  padding-left: 1.5em !important;\n  margin-bottom: 0.5em !important;\n}\n\n.feature-description ul {\n  list-style-type: disc !important;\n}\n\n.feature-description ol {\n  list-style-type: decimal !important;\n}\n\n/* Testimonials Text */\n.testimonial-text p {\n  margin-bottom: 0.5em;\n}\n\n.testimonial-text strong {\n  font-weight: bold !important;\n}\n\n.testimonial-text em {\n  font-style: italic !important;\n}\n\n/* CTA Description */\n.cta-description p {\n  margin-bottom: 0.5em;\n}\n\n.cta-description strong {\n  font-weight: bold !important;\n}\n\n.cta-description em {\n  font-style: italic !important;\n}\n\n.cta-description ul,\n.cta-description ol {\n  padding-left: 2em !important;\n  margin-bottom: 1em !important;\n}\n\n.cta-description ul {\n  list-style-type: disc !important;\n}\n\n.cta-description ol {\n  list-style-type: decimal !important;\n}\n\n/* Quill alignment classes */\n.ql-align-center {\n  text-align: center !important;\n}\n\n.ql-align-right {\n  text-align: right !important;\n}\n\n.ql-align-justify {\n  text-align: justify !important;\n}\n\n/* Quill font sizes */\n.ql-size-small {\n  font-size: 0.75em !important;\n}\n\n.ql-size-large {\n  font-size: 1.5em !important;\n}\n\n.ql-size-huge {\n  font-size: 2.5em !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
